'use strict';
export let dateRange:any[] = ['$rootScope', ($rootScope) => {
    var DATE_FORMAT = "DD.MM.YYYY";

    function getOtherType(type) {
        if (type === 'from') {
            return 'to';
        }
        return 'from';
    }

    function getFullEventName(name, id, type) {
        return name + '-' + id + '-' + type;
    }

    function areDatesInOrder(start, end) {
        if (!start || !end) {
            return true;
        }
        return moment(end, DATE_FORMAT).toDate().getTime() >= moment(start, DATE_FORMAT).toDate().getTime();
    };

    class DateRangeDirective {
        restrict = 'A';
        require = 'ngModel';
        scope = {};

        link(scope, element, attr, ngModelCtrl) {
            var prop = attr.daterange.split('|');
            var markTo = !!attr.daterangeMarkTo;
            if (prop.length < 2 || prop.length > 3) {
                throw "Invalid number of properties";
            }
            var id = prop[0];
            var type = prop[1];
            var enabledExpression = prop.length > 2 ? prop[2] : null;

            ngModelCtrl.$parsers.push(function (viewValue) {
                $rootScope.$broadcast(getFullEventName('daterange-change', id, getOtherType(type)), viewValue);
                return viewValue;
            });

            scope.$on(getFullEventName('daterange-change', id, type), function (event, value) {
                var valid = type === 'from' ? areDatesInOrder(ngModelCtrl.$viewValue, value) : areDatesInOrder(value, ngModelCtrl.$viewValue);
                ngModelCtrl.$setValidity('daterange', valid || (!markTo && type === 'to'));
                $rootScope.$broadcast(getFullEventName('daterange-valid', id, getOtherType(type)), valid);
            });

            if (type === 'from' || markTo) {
                scope.$on(getFullEventName('daterange-valid', id, type), function (event, valid) {
                    ngModelCtrl.$setValidity('daterange', valid);
                });
            }

            if (enabledExpression && type === 'from') {
                scope.$watch(
                    () => scope.$eval(enabledExpression),
                    (isEnabled) => {
                        if (isEnabled) {
                            $rootScope.$broadcast(getFullEventName('daterange-change', id, 'to'), ngModelCtrl.$viewValue);
                        } else {
                            ngModelCtrl.$setValidity('daterange', true);
                            $rootScope.$broadcast(getFullEventName('daterange-valid', id, 'to'), true);
                        }
                    }
                );
            }
        }
    }

    return new DateRangeDirective();
}];


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/date-range.directive.ts